export const LOAD_TOR_NODES_LIST = 'LOAD_TOR_NODES_LIST';
export const RESTART_TOR_NODE = 'RESTART_TOR_NODE';
export const RESTART_TOR_SERVICE = 'RESTART_TOR_SERVICE';
export const LOAD_SCRIPTS_LIST = 'LOAD_SCRIPTS_LIST';
export const RESTART_SCRIPT = 'RESTART_SCRIPT';
export const STOP_SCRIPT = 'STOP_SCRIPT';
export const RESET_SERVER = 'RESET_SERVER';
